export const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-gray-900 border border-gray-700 rounded-lg p-3 shadow-xl">
        <p className="text-gray-400 text-sm mb-1">{label}</p>
        {payload.map((entry) => (
          <p key={entry.dataKey || entry.name} style={{ color: entry.color }} className="font-semibold">
            {entry.name}: {typeof entry.value === 'number' ? entry.value.toFixed(2) : entry.value} {entry.name.includes('Asset') || entry.name.includes('Activos') ? '' : 'USDT'}
          </p>
        ))}
      </div>
    );
  }
  return null;
};
